module.exports = __webpack_public_path__ + "static/media/digital-retouching-white.b1e31ce8.svg";